var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"centered-content"},[_c('h1',[_vm._v("Pricing")]),_c('h2',[_vm._v("Coming soon")]),_c('bw-pricing-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }